export const countryTimezones = {
  'GB': 'Europe/London',
  'ES': 'Europe/Madrid',
  'IE': 'Europe/Dublin',
  'AU': 'Australia/Sydney',
} as const as Record<SupportedCountry, string>

export type CountryCode = keyof typeof countryTimezones
export type Timezone = typeof countryTimezones[CountryCode]
